import { FROM_WEB_VIEW } from 'version-two/utils/constants';

const getIsWebView = () => localStorage.getItem(FROM_WEB_VIEW) === 'true';

export default getIsWebView;
